import type { Extrusion } from "geom/brep";
import { extrudePolyLine2 } from "geom/extrude";
import { planeNew, planeNormal, planeRotateAroundU } from "geom/plane";
import { polyLine2Reverse } from "geom/polyLine2";
import { rect2ByCenterWidthHeight } from "geom/rect2";
import { vec2AngleBetween, vec2Rotate } from "geom/vec2";

export function porchColumnBraceNew(
  x: number,
  y: number,
  tx: number,
  ty: number,
  bottomOfBeam: number,
  braceDist: number,
  braceWidth: number,
): Extrusion {
  const z = bottomOfBeam - 3;
  const zbot = z - braceDist + Math.SQRT2 * braceWidth;
  const ztop = z + Math.SQRT2 * braceWidth;
  const rotation = vec2AngleBetween(0, -1, tx, ty);
  const profile = polyLine2Reverse(rect2ByCenterWidthHeight(0, 0, braceWidth + 0.5, braceWidth));
  const [aux, auy] = vec2Rotate(1, 0, rotation);
  const [avx, avy] = vec2Rotate(0, 1, rotation);
  const rotatedPlane = planeRotateAroundU(planeNew(x, y, zbot, aux, auy, 0, avx, avy, 0), Math.PI / 4);
  const [nx, ny, nz] = planeNormal(rotatedPlane);
  const extrusionDist = Math.sqrt((ztop - zbot) ** 2 + braceDist ** 2);
  return extrudePolyLine2(profile, rotatedPlane, nx * extrusionDist, ny * extrusionDist, nz * extrusionDist);
}
